import { useEffect, useRef } from "react";
import { track } from "@/lib/analytics";

/**
 * Fires a `scroll_depth` event once per 25/50/75/100% milestone.
 */
export default function ScrollDepthTracker() {
  const fired = useRef(new Set());

  useEffect(() => {
    const onScroll = () => {
      const el = document.documentElement;
      const max = el.scrollHeight - el.clientHeight;
      if (max <= 0) return;
      const pct = Math.round((el.scrollTop / max) * 100);
      [25, 50, 75, 100].forEach((m) => {
        if (pct >= m && !fired.current.has(m)) {
          fired.current.add(m);
          track("scroll_depth", { depth: m });
        }
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return null;
}
